<template lang="pug">
  button(@click="execute") {{ canReactivate ? reactivateText : buyText }}
</template>

<script>
  import { mapActions, mapMutations, mapState, mapGetters } from "vuex";

  export default {
    name: 'BtnBuyOrReactivateMemb',

    props: {
      membershipType: {
        type: String,
        required: true
      },

      buyText: {
        type: String,
        default: 'Add to bag'
      },

      reactivateText: {
        type: String,
        default: 'Reactivate'
      },

      productId: {
        type: [String, Number],
        default: null,
      },

      subscription: {
        type: Number,
        default: 4,
      }
    },

    computed: {

      ...mapState('colorbar', ['location']),

      ...mapGetters('colorbar', ['locationId']),

      ...mapState('customer', ['cdata']),

      ...mapState('constants', ['limitlessIds']),

      limitlessId() {
        if (this.productId) {
          return this.productId;
        }

        if (this.membershipType === 'limitlessPro') {
          return this.limitlessIds.PRO;
        }

        if (this.membershipType === 'limitlessProPlus') {
          return this.limitlessIds.PRO_PLUS;
        }

        return null;
      },

      membershipDetails() {
        return this.cdata?.membershipDetails ?? null;
      },

      membership() {
        return this.membershipDetails?.[this.membershipType] ?? null;
      },

      canReactivate() {
        const membership = this.membershipDetails?.[this.membershipType];

        const shouldConsiderLocation = ['limitlessPro', 'limitlessProPlus'].includes(this.membershipType);

        const conditionLocation = shouldConsiderLocation ? membership?.subscriptionLocation === this.location?.code : true;

        return membership?.subscriptionId && conditionLocation &&
          (membership?.subscriptionStatus === 'canceled' ||
            membership?.subscriptionStatus === 'active' && membership?.pendingCancelation
          );
      },
    },

    methods: {
      ...mapActions('cart', ['addMembershipToCart']),

      ...mapActions(['notifyError', 'notifyWarn']),

      ...mapActions('subscriptions', [
        'reactivateMembership',
      ]),

      ...mapMutations('customer', ['setMembershipToReactivate']),

      execute() {
        if (this.canReactivate) {
          return this.doReactivate();
        }

        this.doAddMembershipToCart();
      },

      reactivate() {
        if (this.membership.subscriptionStatus === 'active' && this.membership.pendingCancelation) {
          return this.reactivateMembership({
            subscriptionId: this.membership.subscriptionId,
          }).then(() => {
            location.href = '/dashboard/membership';
          });
        }

        location.href = `/dashboard/membership/reactivate?membershipType=${this.membershipType}`;
      },

      doReactivate() {
        if (!this.canReactivate) {
          this.doAddMembershipToCart();
          return;
        }

        if (this.membershipType === 'limitlessPro' && this.membershipDetails?.limitlessProPlus?.subscriptionStatus === 'active') {
          this.notifyWarn("You're already a Pro+ member. To switch to Pro, cancel your current membership or change memberships from your dashboard.");
          return;
        }

        if (this.membershipType === 'limitlessProPlus' && this.membershipDetails?.limitlessPro?.subscriptionStatus === 'active' && !this.membershipDetails?.limitlessPro?.pendingCancelation) {
          this.notifyWarn("You're already a Pro member. To switch to Pro+, cancel your current membership or change memberships from your dashboard.");
          return;
        }

        this.reactivate();
      },

      doAddMembershipToCart() {
        if (!this.limitlessId) {
          this.notifyError('We were unable to process your purchase. Please review your information or call us at ' + window.MR.config.contactPhone);
          return;
        }

        this.addMembershipToCart({
          productId: this.limitlessId,
          qty: 1, subscription: this.subscription,
          locationId: this.locationId,
        }).then(() => {
          this.trackMREventAndRedirect(`HCB memberships landing page comparison module - ${this.membership?.membershipName} added to bag`,'/cart');
        }).catch((err) => {
          if (err?.response?.data?.code === "MEMBERSHIP_IN_CART") {
            this.trackMREventAndRedirect(`HCB memberships landing page comparison module - ${this.membership?.membershipName} already in cart and redirecting`,'/cart');
          }
        });
      },
    }
  };
</script>

<style lang="stylus">

</style>